import {EntityType} from "../../const/item";

export enum DeltaEventMethodType {
    NEW     = 'new',
    DELETE  = 'delete',
    DELTA   = 'delta',
    MOVE    = 'move'
}

// voobche to eto strannya tema,..,. eto ne session event,... a pochemu ? a hez ... aaaa...
export type DeltaEvent = {
    name    : EntityType | string
    method  : DeltaEventMethodType
    header  : any
    data    : any
}

// deprecated
export enum TaskUpdateType {
    NEW                 = 'task.new',
    DELETE              = 'task.delete',
    DELTA               = 'task.delta',

    ADD_DEPENDENCY      = 'task.add-dependency',
    REMOVE_DEPENDENCY   = 'task.remove-dependency',

    MESSAGE_NEW         = 'task.message-new',
    MESSAGE_DELETE      = 'task.message-delete',
    MESSAGE_DELTA       = 'task.message-delta',
}

export enum UpdateType {

    TASK_NEW                 = 'task.new',
    TASK_DELETE              = 'task.delete',
    TASK_DELTA               = 'task.delta',

    TASK_ADD_DEPENDENCY      = 'task.add-dependency',
    TASK_REMOVE_DEPENDENCY   = 'task.remove-dependency',

    TASK_MESSAGE_NEW         = 'task.message-new',
    TASK_MESSAGE_DELETE      = 'task.message-delete',
    TASK_MESSAGE_DELTA       = 'task.message-delta',

    DEPENDENCY_NEW          = 'dependency.new',
    DEPENDENCY_DELETE       = 'dependency.delete',

    RELATION_NEW            = 'relation.new',
    RELATION_DELETE         = 'relation.delete',

    TIME_REPORT_NEW         = 'time-report.new',
    TIME_REPORT_DELETE      = 'time-report.delete',
    TIME_REPORT_DELTA       = 'time-report.delta',

    PROJECT_NEW             = 'project.new',
    PROJECT_DELETE          = 'project.delete',
    PROJECT_DELTA           = 'project.delta',

    EVENT_NEW               = 'event.new',
    EVENT_DELETE            = 'event.delete',
    EVENT_DELTA             = 'event.delta' ,

    MEETING_NEW             = 'meeting.new',
    MEETING_DELETE          = 'meeting.delete',
    MEETING_DELTA           = 'meeting.delta',

    EXPENSE_NEW             = 'expense.new',
    EXPENSE_DELETE          = 'expense.delete',
    EXPENSE_DELTA           = 'expense.delta',

    CHAT_MESSAGE_DELTA      = 'chat-message.delta',

    GOAL_NEW                = 'goal.new',
    GOAL_DELETE             = 'goal.delete',
    GOAL_DELTA              = 'goal.delta',
    GOAL_NEW_ROOT           = 'goal.new-root',

    COMMENT_NEW             = 'comment.new',
    COMMENT_DELETE          = 'comment.delete',
    COMMENT_DELTA           = 'comment.delta',

    REMINDER_NEW            = 'reminder.new',
    REMINDER_DELETE         = 'reminder.delete',
    REMINDER_DELTA          = 'reminder.delta',

    TODO_NEW                = 'todo.new',
    TODO_DELETE             = 'todo.delete',
    TODO_DELTA              = 'todo.delta',
}

export type UpdateAction = {
    updateType  : TaskUpdateType | UpdateType
    payload     : any
}